export const MediaTestIds = {
  buttonCancelDownload: 'button_cancel_download',
  buttonConfirmDownload: 'button_confirm_download',
  dialogDownloadContent: 'dialog_download_content',
  dialogDownloadActions: 'dialog_download_actions',
  buttonCancelBulkDownload: 'button_cancel_bulk_download',
  buttonConfirmBulkDownload: 'button_confirm_bulk_download',
  dialogBulkDownloadContent: 'dialog_bulk_download_content',
  dialogBulkDownloadActions: 'dialog_bulk_download_actions'
} as const;
